import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { config } from "@/configs/config";
import { ThemeCountry } from "@/enums";

export const baseURL = config.base_url_uz;

const getBaseUrl = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const domain = window.location.origin;
  const currentTheme = window?.location?.href?.split(
    "country=",
  )?.[1] as ThemeCountry;

  if (domain.includes("boxette.uz") || currentTheme === ThemeCountry.UZ) {
    return config.base_url_uz;
  }
  if (domain.includes("boxette.ge") || currentTheme === ThemeCountry.GEORGIA) {
    return config.base_url_ge;
  }
  if (
    domain.includes("easyxpress.com.ua") ||
    currentTheme === ThemeCountry.UK
  ) {
    return config.base_url_uk;
  }

  return config.base_url_uz;
};

export const axiosInstance = axios.create({
  baseURL: getBaseUrl(),
});

axiosInstance.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (
      error?.response &&
      error?.response?.status === 401 &&
      !error?.request?.responseURL?.includes("/common/log-in")
    ) {
      localStorage.removeItem("token");
      window.location.href = "/log-in";
    }
    if (error?.response?.status === 500) {
      toast.error("Internal Server Error - Please try again later.", {
        position: "top-center",
      });
    }
    return Promise.reject(error);
  },
);
